import React from "react";
import { Target, CheckCircle, Wallet, Heart, TrendingUp, Utensils } from "lucide-react";
import Reveal from "./Reveal";
import TiltCard from "./TiltCard";

const BENEFITS = [
  {
    id: 1,
    title: "Personalised Programs",
    description: "Training plans built around your goals, experience level, and available equipment.",
    icon: "Target",
    tone: "purple",
  },
  {
    id: 2,
    title: "Coach conversations",
    description: "Ask your AI coach about your plan, your exercises and your next session.",
    icon: "CheckCircle",
    tone: "pink",
  },
  {
    id: 3,
    title: "Workout logging",
    description: "Record your sets, reps and weights alongside your workout.",
    icon: "Wallet",
    tone: "purple",
  },
  {
    id: 4,
    title: "Beginner-Friendly",
    description: "Clear exercise guidance and video demonstrations as you train.",
    icon: "Heart",
    tone: "pink",
  },
  {
    id: 5,
    title: "Progress Tracking",
    description: "Visualise your journey with insights that keep you motivated.",
    icon: "TrendingUp",
    tone: "purple",
  },
  {
    id: 6,
    title: "Nutrition Coaching",
    description: "AI-powered meal planning and macro tracking to fuel your fitness goals.",
    icon: "Utensils",
    tone: "pink",
    comingSoon: true,
  },
];

const iconMap = { Target, CheckCircle, Wallet, Heart, TrendingUp, Utensils };

const Benefits = () => {
  return (
    <section className="benefits-section" id="benefits">
      <div className="container">
        <Reveal className="section-header">
          <h2 className="section-title">What You Get</h2>
          <p className="section-subtitle">
            Features designed to help you succeed. Nutrition coaching is coming soon.
          </p>
        </Reveal>

        <div className="benefits-grid">
          {BENEFITS.map((benefit, idx) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <TiltCard
                key={benefit.id}
                className={`benefit-card ${benefit.comingSoon ? "coming-soon" : ""}`}
                variant="scale-pop"
                delay={idx * 80}
                strength={0.55}
              >
                {benefit.comingSoon && (
                  <span className="coming-soon-badge">Coming Soon</span>
                )}
                <div className={`benefit-icon benefit-icon-${benefit.tone}`}>
                  {IconComponent && <IconComponent size={26} strokeWidth={1.8} />}
                </div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </TiltCard>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
